<template>
  <div class="personal">
    <el-container>
      <el-aside width="256px">
        <div class="account-info">
          <staff-avatar
            :size="40"
            :user="curUser"
            :compress="false"
            style="margin-left: 29px;"
          ></staff-avatar>
          <span class="font-main" style="margin-left: 8px;">{{ curUser.username }}</span>
        </div>
        <side-menu :default-active="this.$router.currentRoute.name" @select="menuSelect">
          <el-menu-item index="system-personal-setting">
            <span slot="title">个人信息</span>
          </el-menu-item>
          <el-menu-item index="system-personal-password">
            <span slot="title">账号密码</span>
          </el-menu-item>
          <el-menu-item index="system-personal-companies">
            <span slot="title">已加入企业</span>
          </el-menu-item>
        </side-menu>
      </el-aside>
      <el-main>
        <router-view ref="child"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideMenu from "@/components/UIComponents/SideMenu"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "Personal",
  components: {
    StaffAvatar,
    SideMenu
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    menuSelect(routeName) {
      if (this.$router.currentRoute.name === routeName) return
      this.$router.push({ name: routeName })
    }
  }
}
</script>

<style lang="scss" scoped>
.personal {
  width: 100%;
  padding: 20px 0 0 0;
  .account-info {
    display: flex;
    align-items: center;
    width: 256px;
    height: 72px;
    background: #ffffff;
    margin-bottom: 6px;
  }
  .el-container {
    width: 1146px;
    margin: 0 auto;
    .el-menu {
      background: #ffffff;
    }
    .el-main {
      margin-left: 10px;
      background: #ffffff;
    }
  }
}
</style>
